import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivateBeachIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivateBeachIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5338 13.2449H20.9962V11.6288C20.9789 9.8541 19.4587 8.73634 17.7528 8.91353C16.2555 8.91348 15.0375 10.1315 15.0375 11.6288V13.2449H14.4999C13.7583 13.2449 13.1553 13.875 13.1553 14.649V20.15C13.1553 20.924 13.7583 21.554 14.4999 21.554H21.5338C22.2749 21.554 22.878 20.924 22.878 20.15V14.649C22.878 13.875 22.2749 13.2449 21.5338 13.2449ZM15.9739 11.6288C15.9739 10.6476 16.7717 9.84983 17.7528 9.84983H18.2809C19.262 9.84983 20.0598 10.6476 20.0598 11.6288V13.2449H15.9739L15.9739 11.6288ZM21.9416 20.15C21.9416 20.4078 21.7588 20.6177 21.5338 20.6177H14.4999C14.2749 20.6177 14.0916 20.4078 14.0916 20.15V14.649C14.0916 14.3911 14.2749 14.1813 14.4999 14.1813H21.5338C21.7588 14.1813 21.9416 14.3911 21.9416 14.649V20.15Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0166 15.0006C15.826 15.0301 15.4526 18.1196 17.5484 18.6795V19.6823C17.5484 19.9411 17.7578 20.1505 18.0166 20.1505C18.2754 20.1505 18.4848 19.9411 18.4848 19.6823V18.6795C20.5819 18.1188 20.2057 15.0296 18.0166 15.0006ZM18.0166 17.8096C16.782 17.7771 16.7822 15.9693 18.0166 15.9369C19.2512 15.9695 19.251 17.7772 18.0166 17.8096Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7509 15.0006H4.72842C4.46965 15.0006 4.26025 15.21 4.26025 15.4688C4.26025 15.7275 4.46965 15.9369 4.72842 15.9369H11.7509C12.3642 15.9274 12.3681 15.0109 11.7509 15.0006Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.2827 16.8737H3.45792C3.19936 16.8737 2.98975 17.0833 2.98975 17.3418C2.98975 17.6004 3.19936 17.81 3.45792 17.81H11.2827C11.8927 17.8015 11.9026 16.8842 11.2827 16.8737Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2985 2.9563C16.5432 2.2563 15.3819 2.27963 14.655 3.00613L13.2459 4.41524C13.0692 4.59195 12.8325 4.69753 12.5826 4.6994C11.7657 4.70574 10.6693 4.56333 10.062 5.2583L6.13286 9.1874L4.8349 7.8894C4.45409 7.50859 3.96433 7.30522 3.46501 7.27426C3.20405 7.258 2.98975 7.48251 2.98975 7.74399C2.98975 7.98727 3.17576 8.19047 3.41843 8.20787C3.69357 8.2277 3.96257 8.34117 4.17285 8.55145L7.61145 11.99C8.35002 12.7286 9.51431 12.8249 10.3642 12.2177L11.5528 11.3685C11.9589 11.0783 12.5022 11.0695 12.9176 11.3462L13.8302 11.9543C14.046 12.097 14.3363 12.0393 14.4794 11.8244C14.623 11.6092 14.5644 11.3184 14.3496 11.1753L13.436 10.5665C12.6975 10.0744 11.7318 10.0902 11.0097 10.606L9.82078 11.4556C9.34292 11.797 8.68827 11.7428 8.273 11.3275L6.79488 9.84943L10.724 5.92025C11.1149 5.481 11.9572 5.67575 12.561 5.63584C13.0694 5.63592 13.5476 5.43743 13.9079 5.07719L15.317 3.66808C15.6858 3.2993 16.2804 3.28833 16.6625 3.64337L19.8426 6.59765C19.8511 6.6061 22.1893 8.77748 22.2001 8.78788C22.6498 9.2025 23.2842 8.52111 22.8374 8.10194L17.2985 2.9563Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PrivateBeachIcon;
